import React from 'react';
import './myob-terms-and-conditions.scss';
import { Typography, Anchor } from '@ampol/design-system';
import Links from 'constants/links';

/**
 * MYOB Terms and Conditions
 * @returns JSX Element
 */
const MyobTermsAndConditions = () => {
  return (
    <div className="myob-terms-and-conditions">
      <Typography component="h4">
        <i>
          Ampol is a proud partner of accounting software provider, MYOB. If you are an existing MYOB customer you can
          link your AmpolCard account and your MYOB account so the data from your AmpolCard statement is transferred to
          MYOB.
        </i>
      </Typography>

      <Typography component="small">
        By clicking and accepting these Terms and Conditions you agree that Ampol Australia Petroleum Pty Ltd (ACN 000
        032128) (Ampol, our, we) may transfer your transaction information from your AmpolCard account (Records) to MYOB
        Australia Pty Limited (ABN 13 086 760 198) (MYOB) (the Service) in accordance with these Terms. MYOB will
        incorporate the Data into your MYOB accounting information.
      </Typography>

      <Typography component="small">
        These Terms include our{' '}
        <Anchor variant="small" href={Links.PRIVACY_AND_REPORTING_POLICY}>
          Privacy Policy
        </Anchor>
        , which you should review and which is incorporated into these Terms by reference.
      </Typography>
      <Typography component="h4">Changes to the Service or these Terms</Typography>

      <Typography component="small">
        We may make changes to the Service or amend these Terms at any time by notifying you at the email address you
        provided to us for your AmpolCard account. If you do not agree to the changes to the Service or these Terms you
        may cancel the Service. Your continued use of the Service after we have notified you of the changes will be
        deemed to constitute acceptance of the changes.
      </Typography>

      <Typography component="h4">No Change to AmpolCard Invoicing and Billing</Typography>

      <Typography component="small">
        We will continue to invoice you for your AmpolCard transactions as we normally would and you will continue to
        pay your AmpolCard invoices in the same way as you normally would.
      </Typography>

      <Typography component="small">
        The AmpolCard Facility and Bulk Standard Terms and Conditions (see{' '}
        <Anchor variant="small" href={Links.AMPOL}>
          ampol.com.au
        </Anchor>
        ) will continue to apply and if there is any inconsistency between these Terms and the AmpolCard Facility and
        Bulk Standard Terms and Conditions, the AmpolCard Facility and Bulk Standard Terms and Conditions will prevail
        to the extent of the inconsistency.
      </Typography>

      <Typography component="h4">Privacy</Typography>

      <Typography component="small">
        The Data may contain personal information about you and you consent to the disclosure of that personal
        information by us to MYOB. The Data, including any personal information will be maintained by MYOB in accordance
        with your agreement with MYOB.
      </Typography>

      <Typography component="h4">No Liability for the Service</Typography>

      <Typography component="small">
        To the maximum extent permitted by law, we are not liable for any loss or damage you may suffer as a result of
        us providing the Service to you.
      </Typography>

      <Typography component="small">
        You will defend, hold harmless and indemnify us from and against any and all loss suffered or incurred by us
        arising out of or in connection with any data (including personal information) disclosed by you in connection
        with the Service.
      </Typography>

      <Typography component="small">
        No agency, partnership or joint venture exists between us and MYOB in relation to the Service. We accept no
        liability or responsibility for the acts and omissions, fraud or negligence of MYOB including its employees and
        agents.
      </Typography>

      <Typography component="h4">Cancelling the Service</Typography>

      <Typography component="small">
        You may cancel this Service at any time by going to the &apos;My Ampol Cards&apos; web portal and clicking the Deregister
        link.
      </Typography>

      <Typography component="small">
        We may cancel this Service at any time and we will notify you of the cancellation at the email address you have
        provided to us for your AmpolCard account.
      </Typography>

      <Typography component="small">
        We may cancel this Service if your AmpolCard account has been terminated for any reason.
      </Typography>

      <Typography component="h4">Service Faults and Service Outages</Typography>

      <Typography component="small">
        If you are experiencing any faults with the Service please contact us at:
      </Typography>
      <Typography component="small">
        AmpolCard Support: 1300 365 096
        <br />
        AmpolCard Online:{' '}
        <Anchor variant="small" href={Links.AMPOL}>
          www.ampol.com.au
        </Anchor>
        <br />
        Address: GPO Box 3998 Sydney NSW 2001
        <br />
        Fax: (02) 9250 5797
        <br />
        E-mail: ampolcard@ampol.com.au
      </Typography>

      <Typography component="small">
        For any scheduled outages that will impact you, we will endeavour to contact you at the email address you have
        provided to us for your AmpolCard account.
      </Typography>

      <Typography component="h4">Other</Typography>

      <Typography component="small">
        These Terms are governed by the laws of New South Wales. Both parties accept the non-exclusive jurisdiction of
        the courts in New South Wales.
      </Typography>
    </div>
  );
};

export default MyobTermsAndConditions;
